import { Component, OnInit } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'gipAdmUserPwdReset',
  templateUrl: './gipAdmUserPwdReset.component.html',
  styleUrls: ['./gipAdmUserPwdReset.component.css']
})
export class GipAdmUserPwdResetComponent implements OnInit {

  constructor(
    private shareData: SharingDataService,
  ) { }

  formular = [
    { formControlName: "NEWPASSWORD", required: true, password: true, newRow: true, type:"password" },
    { formControlName: "NEWPASSWORDCONFIRM", required: true, password: true, newRow: true, function: "comparePassword", type:"password"  },
  ]

  resourceDefinition

  modelInput = new FormGroup({
    NEWPASSWORD: new FormControl(),
    NEWPASSWORDCONFIRM: new FormControl(),
  });

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
  }

  action(action) {
    this[action]();
  }

  enableResetPasswordButton(){
    return this.modelInput.status == "VALID" && this.comparePassword();
  }

  comparePassword(){
    if(this.modelInput.value.NEWPASSWORD == this.modelInput.value.NEWPASSWORDCONFIRM && this.modelInput.value.NEWPASSWORDCONFIRM && this.modelInput.value.NEWPASSWORD){
      return true;
    }
  }

  resetPassword(){

  }

}
